<template>
  <div class="SearchResultbg">
    <template v-if="searchCourseResult.length == 0">
      <div class="topictext">Course Not Found</div>
    </template>
    <template v-else>
      <div class="topictext">Found course</div>
      <br />
      <div class="containerDangers">
        <div class="wrapper pl-3" id="content-free" ref="contentFree">
          <div
            class="column"
            v-for="(item, index) in this.searchCourseResult"
            :key="index"
          >
            <mdlCard
              :data="item"
              type="normal"
              :index="indexCourse"
              @move="move"
              @tellMeWhenYouReady="tellMeWhenYouReady"
            />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Service from "../service/api";
import courseSearch from "../components/showSingleCard/CourseCardSearch";
import mdlCard from "../components/showSingleCard/MdlCard";

export default {
  props: {
    searchCourse: String,
  },
  data() {
    return {
      allCourse: [],
      searchCourseResult: [],
    };
  },
  components: {
    courseSearch,
    mdlCard,
  },
  created() {},
  computed: {
    ...mapGetters(["getAllCourse"]),
  },
  watch: {
    searchCourse: function(val) {
      if (val != "") {
        this.fetchAllCourses();
      }
    },
  },
  mounted() {
    if (this.searchCourse !== "") {
      this.fetchAllCourses();
      if (this.$store.getters["auth/userStatus"]) {
        this.$store.dispatch("auth/fetchCourseEducation");
      }
    }
  },
  methods: {
    fetchAllCourses() {
      Service.fetchAllCourses()
        .then((res) => {
          this.allCourse = res.data.data;
          if (this.allCourse.length !== 0) {
            this.onSearchResult(this.searchCourse.toLowerCase());
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSearchResult(searchCourse) {
      if (this.allCourse.length !== 0) {
        this.searchCourseResult.splice(0, this.searchCourseResult.length);
        let initCourse = this.allCourse;
        for (let i = 0; i < initCourse.length; i++) {
          let title = initCourse[i].title;
          let name = initCourse[i].name;
          for (let index = 0; index < title.length; index++) {
            let matchTitle = title[index].val.toLowerCase();
            let matchName = name[index].val.toLowerCase();
            if (
              matchTitle.match(searchCourse) != null ||
              matchName.match(searchCourse) != null
            ) {
              this.searchCourseResult.push(initCourse[i]);
            }
          }
        }
      }
    },
  },
  beforeDestroy() {},
};
</script>
<style scoped>
.animatedBox {
  cursor: pointer;
  /* margin-right: 3px; */
  transition: margin 0.4s ease-out;
}

.animatedBox.active {
  margin-right: 0.8rem;
}
.viewAllImage {
  border-radius: 50%;
  opacity: 0.8;
  vertical-align: center;
}
/* container for store cards */
.containerDangers {
  padding-right: 4rem;
  margin-left: 4rem;
  position: relative;
  width: 100%;
  height: 220px;
}

.containerDangers .wrapper {
  float: left;
  width: 100%;
  /* height: 100%; */
  margin: 1px;
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  overflow-x: auto;
}

.containerDangers .wrapper .viewAllIconContainer {
  text-align: center;
  /* height: 220px; */
  /* line-height: 220px; */
  line-height: 17rem;
}

.containerDangers .wrapper .viewAllIconContainer img {
  vertical-align: middle;
}

.containerDangers .wrapper .viewAllIconContainer:hover {
  cursor: pointer;
}

.containerDangers .wrapper::-webkit-scrollbar {
  display: none;
}

.containerDangers .wrapper .itemC {
  /* height: 100%; */
  bottom: 0;
  display: inline-block;
}

.containerDangers .left {
  text-align: center;
  z-index: 1;
  position: absolute;
  left: 0;
  width: 3%;
  height: 105%;
  margin-top: 1.1rem;
  color: white;
  background: black;
  opacity: 0.2;
}

.containerDangers .right {
  text-align: center;
  z-index: 1;
  position: absolute;
  right: 3.75rem;
  width: 3%;
  height: 105%;
  margin-top: 1.1rem;
  color: white;
  background: black;
  opacity: 0.2;
}

.containerDangers .left:hover,
.containerDangers .right:hover {
  cursor: pointer;
  opacity: 0.6;
  background: grey;
  height: 105%;
}

@media only screen and (max-width: 600px) {
  .containerDangers {
    position: relative;
    width: 100%;
    height: 220px;
  }

  .containerDangers .left {
    width: 7%;
  }

  .containerDangers .right {
    width: 7%;
  }
}
.viewAllText {
  /* padding-top: 0.5rem; */
  margin-top: auto;
  margin-bottom: -0.5rem !important;
}
.viewAllText:hover {
  cursor: pointer;
  /* padding-top: 0.5rem */
}
.topicText {
  margin-left: 3.5rem;
  padding-left: 0.35rem;
  text-align: left;
  font: Bold 30px/39px Roboto;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  font-family: Roboto;
  font-weight: bold;
  margin-bottom: -1.5rem !important;
}
.SearchResultbg {
  padding-top: 5em;
  padding-bottom: 8em;
  background-blend-mode: darken;
  overflow: hidden;
  background-image: url("../assets/icons/homepage/HOMEBG.png");
  padding-top: 56px;
  /* Full height */
  min-height: 100vh;
  width: 100%;
  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 85px;
}
.topiccourse {
  height: auto;
  margin-left: 3rem;
  display: flex;
}
.topictext {
  text-align: left;
  font: Bold 30px/39px Roboto;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  font-family: Roboto;
  font-weight: bold;
  margin-left: 3rem;
}
.column {
  width: 20%;
  padding: 10px;
  height: 300px;
  margin-right: -65px;
  display: inline-block;
  min-width: 300px;
  /* margin-left: 3rem; */
}
.row:after {
  content: "";
  display: table;
  clear: both;
  width: 22rem;
  /* width: 22rem; */
}
</style>
